import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(enLocale)

// Resolves a country to its uppercase ISO-3166 alpha-2 code. Prefers an
// explicit 2-letter code; otherwise resolves the English name via
// i18n-iso-countries (handles variants like "Czech Republic"/"Czechia").
// Returns '' when neither resolves.
export const resolveCountryCode = (code?: string, name?: string): string => {
  if (code && /^[a-zA-Z]{2}$/.test(code)) return code.toUpperCase()
  const iso = name ? countries.getAlpha2Code(name.trim(), 'en') : undefined
  return iso || ''
}
